import React, { FC } from 'react';
import { StepCircleStatus } from 'modules/core/enums/stepCircleStatus.enum';

import { ProgressCar, ProgressFill, ProgressTrack, ProgressTrackWrap, Step, StepLine, Steps, Wrapper } from './styles';
import { StepCircle } from './StepCircle';

interface ISequentialProgressBarProps {
  stepLabels: string[];
  activeStep: number;
  isFailed: boolean;
}

const STEP_PERCENT_FIRST = 10;
const STEP_PERCENT_LAST = 90;

export const SequentialProgressBar: FC<ISequentialProgressBarProps> = ({ stepLabels, activeStep, isFailed }) => {
  const getStatus = (stepIndex: number): StepCircleStatus => {
    const stepNumber = stepIndex + 1;

    if (activeStep === stepNumber) return isFailed ? StepCircleStatus.FAILED : StepCircleStatus.IN_PROGRESS;

    if (activeStep > stepNumber) return StepCircleStatus.COMPLETED;

    return StepCircleStatus.NOT_STARTED;
  };

  const getStepPercent = (activeStep: number, totalSteps: number): number => {
    if (activeStep > totalSteps) return 100;

    if (totalSteps === 1) return STEP_PERCENT_FIRST;

    const index = activeStep - 1;

    return Math.round(STEP_PERCENT_FIRST + (index * (STEP_PERCENT_LAST - STEP_PERCENT_FIRST)) / (totalSteps - 1));
  };

  const displayPercent = Math.min(100, getStepPercent(activeStep, stepLabels.length));

  return (
    <Wrapper>
      <ProgressTrackWrap>
        <ProgressTrack>
          <ProgressFill $pct={displayPercent} />
        </ProgressTrack>
        <ProgressCar $pct={displayPercent} aria-hidden />
      </ProgressTrackWrap>

      <Steps>
        {stepLabels.map((step, index) => (
          <React.Fragment key={step}>
            {index > 0 && <StepLine />}
            <Step>
              <StepCircle status={getStatus(index)} />
              <div>{step}</div>
            </Step>
          </React.Fragment>
        ))}
      </Steps>
    </Wrapper>
  );
};
